import { render, staticRenderFns } from "./RouteDetails.vue?vue&type=template&id=2fd70d14&"
import script from "./RouteDetails.vue?vue&type=script&lang=js&"
export * from "./RouteDetails.vue?vue&type=script&lang=js&"
import style0 from "./RouteDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RouteDetails.vue"
export default component.exports